import { useRef } from 'react'

/**
 * Devolve o `value` do primeiro render e só volta a lê-lo quando `key` muda.
 *
 * Feito para a posição inicial de player: o valor de origem (progresso salvo,
 * aula concluída) continua mudando durante a reprodução, e repassar a mudança a
 * um player vivo faz ele recarregar o vídeo.
 */
export function useFirstValuePerKey<T>(value: T, key: unknown): T {
  const captured = useRef({ key, value })
  if (captured.current.key !== key) {
    captured.current = { key, value }
  }
  return captured.current.value
}
